import Policy from './policy';

export default Policy;
